<div class="container px-0 px-md-5">
  <div class="card shadow px-3 px-md-5 pt-0">
    <h4 class="font-weight-bold pt-5 text-center">
      {{ "BAZZAR.RESET_PASSWORD" | translate }}
    </h4>
    <div class="col-lg-6 offset-lg-3 col-md-8 offset-md-2">
      <hr />
      <form action="" class="pt-5" [formGroup]="resetPasswordForm">
        <div class="form-group mx-0 mb-5">
          <label class="my-auto text-left font-14px font-weight-bold pl-0 pb-3">
            {{ "BAZZAR.NEW_PASSWORD" | translate }}
          </label>
          <input
            type="password"
            formControlName="newPassword"
            required
            minlength="6"
            maxlength="100"
            class="form-control"
          />
          <mat-error
            class="pl-0"
            *ngIf="
              resetPasswordForm.controls.newPassword.errors?.required &&
              resetPasswordForm.controls.newPassword.touched
            "
            >{{ "BAZZAR.REQUIRED" | translate }}</mat-error
          >

          <mat-error
            *ngIf="resetPasswordForm.controls.newPassword.hasError('minlength')"
          >
            {{ "BAZZAR.PASSWORD_LENGTH" | translate }}
          </mat-error>
        </div>
        <div class="form-group row mx-0 mb-4">
          <label class="my-auto text-left font-14px font-weight-bold pl-0 pb-3">
            {{ "BAZZAR.RETYPE_PASSWORD" | translate }}
          </label>
          <input
            type="password"
            formControlName="retypePassword"
            required
            minlength="6"
            maxlength="100"
            class="form-control"
          />
          <mat-error
            *ngIf="
              resetPasswordForm.controls.retypePassword.errors?.required &&
              resetPasswordForm.controls.retypePassword.touched
            "
            >{{ "BAZZAR.REQUIRED" | translate }}</mat-error
          >

          <mat-error
            *ngIf="
              resetPasswordForm.controls.retypePassword.hasError('minlength')
            "
          >
            {{ "BAZZAR.PASSWORD_LENGTH" | translate }}
          </mat-error>
        </div>
        <div class="form-group py-5 text-center mb-5">
          <button class="btn btn-success w-100">
            {{ "BAZZAR.RESET_PASSWORD" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
